import moment from "moment";
import { mapState } from "vuex";
import {
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  FIXED_TAB,
  FLEXIBLE_TAB,
  otType,
  otTypeFlexible,
  OT_TYPE_FIXED,
  OT_TYPE_FIXED_CONFIG,
  OT_TYPE_FLEXIBLE,
  OT_TYPE_FIXED_IGNORE,
  OT_TYPE_FIXED_CONFIG_IGNORE,
  OT_TYPE_FLEXIBLE_IGNORE,
  Role,
  statusColor,
  statusText,
  statusTextReverse,
  STATUS_FLEXIBLE_TEXT,
  TIME_PM,
  TIME_STAFF,
} from "../../components/commons/commonConstant";
import {
  beforeUploadFile,
  checkShowWithLastTimesheet,
  convertObjectToParams,
  disableWeekendCommon,
  downloadFile,
  formatDate,
  formatTime,
  getInfoStaff,
  getMessages,
  getStatus,
  initFilters,
  scaleScreen,
} from "../../components/commons/commons";
import FilterLayout from "../../components/layouts/FilterLayout";
import OvertimeModal from "../../components/OvertimeManagement/OvertimeModal.vue";
import ConfirmOvertimeModal from "../../components/OvertimeManagement/ConfirmOvertimeModal.vue";
import http from "../../store/modules/helpers/httpInterceptor";
import OverTimeDetail from "./OverTimeDetail/OverTimeDetail.vue";
import { getMessageResponseType, handleMessagesAPI } from "@/utils";
import { ImportModalRequest } from "@/components";
const userList = [
  {
    title: "Staff",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
    width: "25%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width: "15%",
  },
  {
    title: "Approver",
    dataIndex: "approver_rejector",
    key: "approver_rejector",
    scopedSlots: { customRender: "approver_rejector" },
    width: "20%",
  },
  {
    title: "Reason for rejection",
    dataIndex: "reason_rejection",
    scopedSlots: { customRender: "reason_rejection" },
    key: "reason_rejection",
    width: "15%",
  },
  {
    title: "",
    dataIndex: "approve_reject",
    key: "approve_reject",
    scopedSlots: { customRender: "approve_reject" },
    width: "15%",
  },
];
const fixedColumns = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    scopedSlots: { customRender: "title_request" },
    width: 250,
  },
  {
    title: "Project",
    dataIndex: "project_name",
    key: "project_name",
    scopedSlots: { customRender: "project_name" },
    width: 300,
  },
  {
    title: "OT Date",
    dataIndex: "ot_date",
    key: "ot_date",
    scopedSlots: { customRender: "ot_date" },
    width: 120,
  },
  {
    title: "OT Time",
    dataIndex: "ot_time",
    scopedSlots: { customRender: "ot_time" },
    customRender(_, record) {
      return `${record?.start_time ?? ""} - ${record?.end_time ?? ""}`;
    },
    key: "ot_time",
    width: 120,
  },
  {
    title: "OT Type",
    dataIndex: "ot_type",
    scopedSlots: { customRender: "ot_type" },
    key: "ot_type",
    width: 120,
  },
  {
    title: "Approver",
    dataIndex: "approver",
    key: "approver",
    scopedSlots: { customRender: "approver" },
    customRender(_, record) {
      return getInfoStaff(record.assignee_ob);
    },
    width: 250,
  },
  {
    title: "Created By",
    dataIndex: "creator",
    key: "creator",
    scopedSlots: { customRender: "creator" },
    customRender(_, record) {
      return getInfoStaff(record.creator);
    },

    // width: 200,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    fixed: "right",
    width: 150,
  },
  {
    title: "Actions",
    dataIndex: "edit",
    key: "edit",
    scopedSlots: { customRender: "edit" },
    fixed: "right",
    align: "center",
    width: 80,
  },
];

const flexibleColumns = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    scopedSlots: { customRender: "title_request" },
    width: 200,
  },
  {
    title: "Staff",
    dataIndex: "requester",
    key: "staff",
    scopedSlots: { customRender: "requester" },
    width: 200,
  },
  {
    title: "Project",
    dataIndex: "project",
    key: "project_name",
    scopedSlots: { customRender: "project" },
    width: 200,
  },
  {
    title: "OT Plan",
    dataIndex: "overtimeDate",
    key: "ot_date",
    scopedSlots: { customRender: "overtimeDate" },
    width: 240,
  },
  {
    title: "OTpay Hours",
    dataIndex: "overtimePayDetail",
    // scopedSlots: { customRender: "otPayHours" },
    customRender(value) {
      if (!value) return "";
      return value?.total_time_actual ?? "";
    },
    key: "otPayHours",
    width: 120,
  },
  {
    title: "OTpay Confirmation",
    dataIndex: "overtimePayDetail",
    // scopedSlots: { customRender: "otPayConfirmation" },
    customRender(value) {
      if (!value) return "";
      return value?.total_time_confirm ?? "";
    },
    key: "otPayConfirmation",
    width: 120,
  },
  {
    title: "Project Manager",
    dataIndex: "pms",
    key: "project_manager",
    scopedSlots: { customRender: "project_manager" },
    // width: 250,
  },
  {
    title: "Manager",
    dataIndex: "approver",
    key: "manager",
    scopedSlots: { customRender: "manager" },
    width: 200,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status_flexible",
    scopedSlots: { customRender: "status_flexible" },
    fixed: "right",
    width: 180,
  },
  {
    title: "Actions",
    dataIndex: "edit_flexible",
    key: "edit_flexible",
    scopedSlots: { customRender: "edit_flexible" },
    fixed: "right",
    align: "center",
    width: 80,
  },
];
const hoverTable = [
  {
    title: "Staff",
    dataIndex: "staff",
    key: "staff",
    width: "80%",
    scopedSlots: { customRender: "staff" },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
  },
];
export default {
  name: "Overtime-Management",
  components: { OverTimeDetail, FilterLayout, OvertimeModal, ConfirmOvertimeModal, ImportModalRequest },
  data() {
    return {
      OTForm: this.$form.createForm(this, { name: "OT Request" }),
      ConfirmForm: this.$form.createForm(this, { name: "Confirm Request" }),
      CancelForm: this.$form.createForm(this, { name: "Cancel Request" }),
      RejectForm: this.$form.createForm(this, { name: "Reject Request" }),
      page: "Overtime-Management",
      currentScreen: "overtime_management_staff",
      countFiles: 0,
      fixedColumns,
      flexibleColumns,
      hoverTable,
      formatDate,
      formatTime,
      getStatus,
      getInfoStaff,
      tableColumns: flexibleColumns,
      statusTextReverse,
      statusText,
      hiddenTable: false,
      clickButtonEdit: false,
      recordSelected: {},
      data: [],
      otType,
      headers: {},
      userList,
      Role,
      statusColor,
      currentPage: 1,
      pageSize: 10,
      field: "Name",
      visibleModal: false,
      sort: { direction: -1 },
      total_items: 0,
      fetching: false,
      timeout: null,
      source: {},
      filters: {},
      firstCall: true,
      recordDetail: {},
      onColumns: {},
      onStatus: {},
      staffOnsiteList: [],
      visibleDrawer: false,
      id: 0,
      tooltipOverTime: { config: { visibleShortenDetail: false } },
      OTDate: "",
      isCreated: true,
      dateOfLastApprovedTimesheet: "",
      endDateOfCurrentTimesheet: "",
      assignee: {},
      visibleModalReject: false,
      visibleModalWithdraw: false,
      visibleModalCancel: false,
      visibleModalConfirm: false,
      reasonReject: "",
      reasonWithdraw: "",
      reasonCancel: "",
      statusPayload: [],
      isEdit: false,
      tempMail: [],
      tempCurrentDate: new Date(),
      arrStaffID: [],
      requestListInfo: {},
      hoverTableHeight: 0,
      renderFirstTime: true,
      isDisableExport: true,
      isCheckedOTPaid: null,
      size: window.outerWidth > 800 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
      tableHeight: window.outerHeight > 800 ? window.outerHeight * 0.6 : window.outerHeight * 0.55,
      fileList: [],
      isAvaiableToDownLoad: false,
      request_type: "overtime",
      tabCurrent: FLEXIBLE_TAB,
      isPms: false,
      projectSelected: {},
      isLoading: false,
      dataOTPay: [],
      LayoutConfirm: {
        labelCol: { span: 12 },
        wrapperCol: { span: 12 },
      },
      overtimeType: OT_TYPE_FIXED,
      OT_TYPE_FLEXIBLE,
      OT_TYPE_FIXED_CONFIG,
      OT_TYPE_FIXED,
      OT_TYPE_FLEXIBLE_IGNORE,
      OT_TYPE_FIXED_CONFIG_IGNORE,
      OT_TYPE_FIXED_IGNORE,
      otTypeFlexible,
      FLEXIBLE_TAB,
      heightTable: 500,
      isShowModalImport: false,
      formUpdate: this.$form.createForm(this, { name: "updateHistory" })
    };
  },
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      allProjectList: (state) => state.application.allProjectList,
      projectListPermission: (state) => state.application.projectListPermission,
      dataOTRequestList: (state) => state.overtime.dataOTRequestList,
      overtimeShift: (state) => state.overtime.overtimeShift,
      otTypeList: (state) => state.application.otTypeList,
      employeeList: (state) => state.application.employeeList,
      userInfo: (state) => state.user.userInfo,
      sameDUStaff: (state) => state.application.sameDUStaff,
      lastTimesheet: (state) => state.application.lastTimesheet,
      employeeByProject: (state) => state.application.employeeByProject,
      loading: (state) => state.user.loading,
      timeServer: (state) => state.application.timeServer,
    }),
  },
  watch: {
    filters: function () {
      if (this.filters.fromDate !== undefined && this.filters.toDate !== undefined) {
        this.isDisableExport = false;
      } else {
        this.isDisableExport = true;
      }
    },
    tabCurrent: function (newValue) {
      if (newValue === FIXED_TAB) {
        this.tableColumns = fixedColumns;
      } else {
        this.tableColumns = flexibleColumns;
      }
      sessionStorage.removeItem(this.page);

      this.filters.status = undefined;
    },
    visibleModalConfirm(newValue) {
      if (!newValue) {
        this.handleClearData();
      }
    },
    visibleModalCancel(newValue) {
      if (!newValue) {
        this.handleClearData();
      }
    },
    visibleModalReject(newValue) {
      if (!newValue) {
        this.handleClearData();
      }
    },
  },
  created() {
    this.overtimeType = this.userInfo.overtimeType;
    if (
      [OT_TYPE_FIXED_CONFIG, OT_TYPE_FLEXIBLE, OT_TYPE_FIXED_CONFIG_IGNORE, OT_TYPE_FLEXIBLE_IGNORE].includes(
        this.overtimeType
      )
    ) {
      this.tabCurrent = FLEXIBLE_TAB;
    } else {
      this.tabCurrent = FIXED_TAB;
      this.$message.error("You have not been set to work schedule");
    }
    this.isPms = this.userInfo.pms;
    this.currentScreen =
      this.userInfo.pms ||
      this.roles?.some((role) => [Role.DULEAD, Role.GROUP_LEAD, Role.HR, Role.HRM, Role.ADMIN].includes(role))
        ? "overtime_management"
        : "overtime_management_staff";
    this.scaleScreen();
    this.handFilters();
    http
      .get("/tms/timesheets/get-end-date-of-last-approved-timesheet")
      .then((res) => {
        this.tempCurrentDate = new Date(res.data.data);
      })
      .catch((error) => {
        throw error;
      });
    this.getLastTimesheetInfo();
    this.firstCall = true;
    window.addEventListener("resize", this.resizeEventHandler);

    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
  },
  beforeMount() {
    this.handleHeightTable();
  },
  methods: {
    moment,
    // Check show action flexible
    scaleScreen,
    handleHeightTable() {
      this.$nextTick(function () {
        const filterWrapper = document.getElementById("filter-wrapper");
        const heightFilterWrapper = filterWrapper.clientHeight ?? 0;
        this.heightTable = document.body.offsetHeight - heightFilterWrapper - 200;
      });
    },
    generateOTPay(data, type) {
      if (!data) return "";
      const { details } = data;
      if (!details || details.length === 0) return "";
      let result = 0;
      let isConfirmed = true;
      details.forEach((shiftDetails) => {
        const { duration_actual, duration_confirm } = shiftDetails;
        if (type === "OTPayHours") {
          result += duration_actual ?? "";
        } else if (type === "OTPayConfirmation") {
          if (duration_confirm === null) {
            isConfirmed = false;
          }
          result += duration_confirm ?? "";
        }
      });
      if (type === "OTPayHours") return Number(result).toFixed(2);
      return isConfirmed ? Number(result).toFixed(2) : "";
    },
    generateTextConfirm(record) {
      const { status } = record;
      if (status === STATUS_FLEXIBLE_TEXT[3]) {
        return "Edit confirmation";
      }
      return "Confirm";
    },
    checkShowAddNew() {
      const { overtimeType, tabCurrent } = this;
      return (
        ((overtimeType === OT_TYPE_FIXED_CONFIG ||
          overtimeType === OT_TYPE_FLEXIBLE ||
          overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
          overtimeType === OT_TYPE_FLEXIBLE_IGNORE) &&
          tabCurrent === FLEXIBLE_TAB) ||
        overtimeType === OT_TYPE_FIXED ||
        overtimeType === OT_TYPE_FIXED_IGNORE
      );
    },
    checkShowEdit(record) {
      return (
        this.checkShowExpired(record.overtimeDate, TIME_STAFF) &&
        record.createdBy?.username === this.userInfo.userName &&
        (record.status === STATUS_FLEXIBLE_TEXT[0] ||
          (record.status === STATUS_FLEXIBLE_TEXT[1] &&
            this.getPmsProject(record).includes(record.createdBy?.username)))
      );
    },
    checkShowCancel(record) {
      return (
        (record.status === STATUS_FLEXIBLE_TEXT[0] &&
          record.requester?.username === this.userInfo.userName &&
          this.checkShowExpired(record.overtimeDate, TIME_STAFF)) ||
        (record.status === STATUS_FLEXIBLE_TEXT[1] &&
          this.getPmsProject(record).includes(this.userInfo.userName) &&
          this.getPmsProject(record).includes(record.createdBy?.username ?? "") &&
          this.checkShowExpired(record.overtimeDate, TIME_PM))
      );
    },
    checkShowConfirm(record) {
      return (
        this.checkShowDayOvertime(record.overtimeDate, record.endTime) &&
        this.checkShowExpired(record.overtimeDate, TIME_PM) &&
        (record.status === STATUS_FLEXIBLE_TEXT[1] || record.status === STATUS_FLEXIBLE_TEXT[3]) &&
        this.getPmsProject(record).includes(this.userInfo.userName)
      );
    },
    checkShowApproveReject(record) {
      return (
        this.checkShowExpired(record.overtimeDate, TIME_PM) &&
        ((record.status === STATUS_FLEXIBLE_TEXT[0] && this.getPmsProject(record).includes(this.userInfo.userName)) ||
          (record.status === STATUS_FLEXIBLE_TEXT[3] &&
            this.getManager(record) === this.userInfo.userName &&
            this.checkShowDayOvertime(record.overtimeDate, record.endTime)))
      );
    },
    checkShowAction(record) {
      return (
        this.checkShowEdit(record) ||
        this.checkShowCancel(record) ||
        this.checkShowConfirm(record) ||
        this.checkShowApproveReject(record)
      );
    },
    getManager(record) {
      const { approver } = record;
      if (approver) {
        return approver.username;
      } else {
        return "";
      }
    },
    getPmsProject(record) {
      const { pms } = record;
      const result = [];
      if (pms && pms.length > 0) {
        pms.forEach((pm) => {
          result.push(pm.username);
        });
      }
      return result;
    },
    checkShowExpired(date, hour) {
      return checkShowWithLastTimesheet(
        date,
        this.lastTimesheet?.last_timesheet_period_end_date,
        hour,
        DATE_FORMAT_V2,
        this.timeServer
      );
    },
    checkShowDayOvertime(date, time) {
      if (date && time) {
        let dateCompare = date + " " + time;
        return moment(new Date()).isAfter(moment(dateCompare, "DD/MM/YYYY HH:mm"));
      }
      return false;
    },
    changeTab(key) {
      this.tabCurrent = key;
      delete this.filters?.status;
      this.getOTRequestList();
    },
    handFilters() {
      const { filters, currentScreen, userInfo, tabCurrent } = this;
      initFilters(filters, currentScreen, userInfo, tabCurrent);
      if (sessionStorage.getItem(this.page)) {
        this.filters = { ...JSON.parse(sessionStorage.getItem(this.page)) };
      } else {
        this.filters = {
          ...this.filters,
          ...JSON.parse(sessionStorage.getItem(this.page)),
        };
      }
    },
    scrollEventHandler() {
      this.tooltipOverTime.config.visibleShortenDetail = false;
    },
    resizeEventHandler() {
      if (document.body.clientHeight > 800) {
        this.tableHeight = document.body.clientHeight * 0.6;
        this.size = document.body.clientWidth * 0.6;
      } else {
        this.tableHeight = document.body.clientHeight * 0.55;
        this.size = document.body.clientWidth * 0.55;
      }
      this.handleHeightTable();
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            if (this.tabCurrent === FLEXIBLE_TAB && !this.clickButtonEdit) {
              this.$router.push(`/timesheet/overtime-management/${record.id}`);
            } else {
              this.isAvaiableToDownLoad = false;
              this.fileList.splice(0, this.fileList.length);
              if (!this.clickButtonEdit) {
                this.visibleDrawer = true;
                this.getAllListFile(record.id);
                this.recordDetail = record;
                this.onColumns = this.userList;
              } else {
                this.clickButtonEdit = false;
              }
            }
          },
        },
      };
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          if (!res) {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data?.message, 5);
        });
    },
    formatDateTime(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY HH:MM:SS");
      }
      return "";
    },
    getOTRequestList() {
      if (this.renderFirstTime) {
        let x = document.getElementsByClassName("TableOverTime")[0].querySelector(".ant-table-body");
        x.addEventListener("scroll", () => {
          this.scrollEventHandler();
        });
      }
      this.renderFirstTime = false;
      this.$store.dispatch("user/loadingRequest");

      const { pageSize, currentPage, sort, filters } = this;
      let param = {};
      if (this.firstCall) {
        param = {
          ...filters,
          ...sort,
        };
        this.currentPage = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
      } else {
        param = {
          ...filters,
          ...sort,
          page: currentPage,
          size: pageSize,
        };
      }
      const url = convertObjectToParams(param);
      let action = "";
      if (this.tabCurrent === FIXED_TAB) {
        action = "overtime/getOTRequestList";
      } else {
        action = "overtime/getOTRequestFlexibleList";
      }
      this.$store
        .dispatch(action, url)
        .then((res) => {
          let dataRespone = [];
          if (res.page) {
            this.total_items = res.page.total_element;
          }
          if (res.data) {
            dataRespone = res.data;
            this.isCheckedOTPaid = res.data.is_ot_paid_by_offset_day;
            this.firstCall = false;
          }
          this.data = dataRespone;
        })
        .catch((error) => {
          this.data = [];
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      sessionStorage.setItem(this.page, JSON.stringify(param));
    },
    changeStatus(data, status, reasonReject, reasonWithdraw) {
      let dataReturn = {
        staff: [],
        is_ot_paid_by_offset_day: false,
        withdraw_reason: reasonWithdraw,
      };
      data.staff.forEach((element) => {
        let temp = {
          approver_id: this.userInfo.userId,
          employee_id: element.employee_id,
          status: status,
          reject_reason: reasonReject,
        };
        dataReturn.staff.push(temp);
      });
      dataReturn.is_ot_paid_by_offset_day = data.is_ot_paid_by_offset_day ? data.is_ot_paid_by_offset_day : false;
      return dataReturn;
    },
    updateStatus(payload) {
      this.$store
        .dispatch("overtime/updateStatusOTRequest", payload)
        .then((res) => {
          if (res) {
            if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
              this.$message.success(res.message);
              this.reasonReject = "";
              this.reasonWithdraw = "";
              this.statusPayload = [];
              this.visibleModalReject = false;
              this.getOTRequestList();
            } else {
              this.$message.error(res.message, 5);
            }
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    async updateStatusFlexible(payload) {
      return this.$store
        .dispatch("overtime/updateStatusOTFlexibleRequest", payload)
        .then((res) => {
          let check = "success";
          if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
            check = "success";
            getMessages(res.message).forEach((msg) => {
              this.$message.success(msg, 5);
            });
          } else if (parseInt(res.code) === 207) {
            check = "warn";
            const messages = getMessages(res.message);
            if (messages && messages.length > 0) {
              for (let i = 0; i < messages.length; i++) {
                if (i === 0) {
                  this.$message.success(messages[i], 5);
                } else {
                  this.$message.warn(messages[i], 5);
                }
              }
            }
            check = "success";
          } else {
            check = "fail";
          }
          if (check === "success" || check === "warn") {
            this.visibleModalConfirm = false;
            this.visibleModalCancel = false;
            this.visibleModalReject = false;
            this.getOTRequestList();
            return true;
          } else {
            getMessages(res.message).forEach((err) => {
              this.$message.error(err, 5);
            });
            return false;
          }
        })
        .catch((errors) => {
          getMessages(errors.response?.data?.message).forEach((err) => {
            this.$message.error(err, 5);
          });
          return false;
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    onClickApprove(record) {
      if (this.tabCurrent === FIXED_TAB) {
        let data = this.changeStatus(record, 3, "");
        let payload = {
          data: data,
          otRequestId: record.id,
        };
        this.updateStatus(payload);
      } else {
        this.updateStatusFlexible({
          requestId: record.id,
          action: "approve",
        });
      }
    },

    onClickReject(record) {
      this.statusPayload = record;
      this.visibleModalReject = true;
    },

    onClickConfirm() {
      const { overtimePayDetail } = this.recordSelected;
      if (!overtimePayDetail || !overtimePayDetail?.details || overtimePayDetail?.details.length <= 0) {
        this.$message.error("Cannot confirm request OT when not have OT pay", 5);
      } else {
        this.$store.dispatch("user/loadingRequest");
        setTimeout(() => {
          this.$store.dispatch("user/loadingRequest");
          this.visibleModalConfirm = true;
        }, 500);
      }
    },
    onClickWithDraw(record) {
      this.statusPayload = record;
      this.visibleModalWithdraw = true;
    },
    onClickCancel(record) {
      this.statusPayload = record;
      this.visibleModalCancel = true;
    },
    onChangePage(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.tooltipOverTime.config = {
        visibleShortenDetail: false,
      };
      this.getOTRequestList();
    },
    onShowSizeChange(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.getOTRequestList();
    },
    onApplyFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.getOTRequestList();
    },
    handleReject() {
      this.RejectForm.validateFields((err, values) => {
        if (!err) {
          if (values?.reasonReject && values?.reasonReject.trim() !== "") {
            if (this.tabCurrent === FIXED_TAB) {
              let data = this.changeStatus(this.statusPayload, 4, this.reasonReject);
              let payload = {
                data: data,
                otRequestId: this.statusPayload.id,
              };
              this.updateStatus(payload);
            } else {
              const payload = {
                requestId: this.recordSelected.id,
                reason: values?.reasonReject.trim() ?? "",
                action: "reject",
              };
              this.updateStatusFlexible(payload);
            }
          } else {
            this.$message.error("Reason reject is required", 5);
          }
        }
      });
    },
    handleWithdraw() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.reasonWithdraw && this.reasonWithdraw.trim() !== "") {
          let data = this.changeStatus(this.statusPayload, 5, "", this.reasonWithdraw);
          let payload = {
            data: data,
            otRequestId: this.statusPayload.id,
          };
          this.updateStatus(payload);
          this.visibleModalWithdraw = false;
        } else {
          this.$message.error("Reasons is required!", 5);
        }
      }, 500);
    },
    handleExecuteCancel() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.CancelForm.validateFields((err, values) => {
          if (!err) {
            if (values?.reasonCancel && values?.reasonCancel.trim() !== "") {
              if (this.recordSelected && this.recordSelected.id) {
                this.updateStatusFlexible({
                  requestId: this.recordSelected.id,
                  action: "cancel",
                  reason: values?.reasonCancel.trim() ?? "",
                });
              }
            } else {
              this.$message.error("Reason cancel is required", 5);
            }
          }
        });
      }, 500);
    },
    handleChangeOTPayConfirm(value, max) {
      if (value > max) {
        this.$message.error("OTpay confirmation can not be higher than total time of shift is " + max, 5);
      }
    },
    handleBlur(event, originValue, key, index) {
      if (event.target.value) {
        const numberFixed = Number.parseFloat(event.target.value).toFixed(2);
        this.ConfirmForm.setFieldsValue({ [key]: numberFixed });
        if (Number.parseFloat(originValue).toFixed(2) === numberFixed) {
          this.dataOTPay[index].required_reason = false;
        } else {
          this.dataOTPay[index].required_reason = true;
        }
      } else {
        this.ConfirmForm.setFieldsValue({
          [key]: originValue,
        });
      }
    },
    // handleFocus() {
    //   this.required_reason = false;
    //   this.ConfirmForm.setFields({
    //     reasonConfirm: {
    //       value: this.ConfirmForm.getFieldValue("reasonConfirm"),
    //     },
    //   });
    // },
    handleConfirm() {
      this.ConfirmForm.validateFields(async (err, values) => {
        if (!err) {
          const data = this.dataOTPay.map((item) => {
            return {
              ...item,
              duration_confirm: values[item.keyHour],
              reason: values[item.keyReason],
            };
          });
          const payload = {
            requestId: this.recordSelected.id,
            action: "confirm",
            details: data,
          };
          const result = await this.updateStatusFlexible(payload);
          if (result) {
            this.getOvertimeRequestDetail();
          }
        }
      });
    },
    handleCancelAction() {
      this.visibleModalReject = false;
      this.visibleModalCancel = false;
      this.visibleModalConfirm = false;
      this.visibleModalWithdraw = false;
    },
    handleClearData() {
      this.ConfirmForm.resetFields();
      this.RejectForm.resetFields();
      this.CancelForm.resetFields();
    },
    handleCancelRejection() {
      this.visibleModalReject = false;
    },
    handleMouseLeave() {
      if (!this.visibleDrawer) {
        this.tooltipOverTime.config.visibleShortenDetail = false;
      }
    },
    handleHoverStatus(event, record) {
      event.preventDefault();
      this.clickButtonEdit = true;
      if (record.staff.length > 0) {
        this.tooltipOverTime.config = {
          visibleShortenDetail: true,
          top: event.pageY + 10 + "px",
          left: event.pageX + 5 + "px",
        };
        this.tooltipOverTime.staff = record.staff;
        this.hoverTableHeight = (document.body.clientHeight - event.pageY) / 2;
      }
    },

    getAssignee() {
      return http
        .get("/tms/filters/get-approver-for-user?username=" + this.userInfo.userName)
        .then((res) => {
          this.assignee = res.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    showModalCreate() {
      this.isAvaiableToDownLoad = false;
      this.fileList.splice(0, this.fileList.length);
      this.$store.dispatch("user/loadingRequest");
      setTimeout(() => {
        this.$store.dispatch("user/loadingRequest");
        this.visibleModal = true;
      }, 500);
      this.isEdit = false;
      // if (this.overtimeType) {
      //   this.$store.dispatch("application/getProjectListPermission", this.userInfo.userName);
      // } else {
      //   this.$store.dispatch("application/getAllProjectList");
      // }
      //   var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
      //   function preventDefault(e) {
      //     e.preventDefault();
      //   }

      //   function preventDefaultForScrollKeys(e) {
      //     if (keys[e.keyCode]) {
      //       preventDefault(e);
      //       return false;
      //     }
      //   }

      //   var supportsPassive = false;
      //   window.addEventListener(
      //     "test",
      //     null,
      //     Object.defineProperty({}, "passive", {
      //       get: function() {
      //         supportsPassive = true;
      //         return supportsPassive;
      //       },
      //     }),
      //   );

      //   var wheelOpt = supportsPassive ? { passive: false } : false;
      //   var wheelEvent = "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

      //   window.addEventListener("DOMMouseScroll", preventDefault, false);
      //   window.addEventListener(wheelEvent, preventDefault, wheelOpt);
      //   window.addEventListener("touchmove", preventDefault, wheelOpt);
      //   window.addEventListener("keydown", preventDefaultForScrollKeys, false);
    },

    handleCancel() {
      this.visibleModal = false;
    },
    onSearchEmployeeByProject(value, timeout, getAll) {
      if (this.projectSelected.projectId) {
        // let cloneVal = decodeURI(value);
        if (getAll || (value && value !== "" && value.length >= 3)) {
          const payload = {
            username: value,
            projectId: this.projectSelected.projectId,
          };
          this.fetching = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.$store
              .dispatch("application/getEmployeeByProject", payload)
              .then((res) => {
                this.fetching = false;
                if (parseInt(res.code) === 400) {
                  this.$message.error(res.message, 5);
                }
              })
              .catch(() => {
                this.fetching = false;
              });
          }, timeout);
        }
      } else {
        this.$message.error("Project is required");
      }
    },
    handleOnClickEdit(record) {
      // this.fileList.splice(0, this.fileList.length);
      this.getAllListFile(record.id);
      this.clickButtonEdit = true;
      this.recordSelected = record;
      // if (!this.roles.includes(Role.GUEST)) {
    },
    showModalEdit() {
      document.body.setAttribute("style", "overflow: hidden !important");
      this.$store.dispatch("user/loadingRequest");
      this.isEdit = true;
      setTimeout(() => {
        this.$store.dispatch("user/loadingRequest");
        this.visibleModal = true;
      }, 2000);
    },

    onSetDataFilters(filters) {
      this.filters = filters;
    },
    handleOnClick(record) {
      if (!this.clickButtonEdit) {
        this.visibleDrawer = true;
        this.recordDetail = record;
        this.onColumns = this.userList;
      } else {
        this.clickButtonEdit = false;
      }
    },

    onClose() {
      this.visibleDrawer = false;
      this.$refs.setFields.handleCancel();
      this.tooltipOverTime = { config: { visibleModal: false } };
    },
    checkStatusPending(data) {
      data.pendingCounter = 0;
      for (let index = 0; index < data.staff.length; index++) {
        if (data.staff[index].status.toUpperCase() === "PENDING") {
          data.pendingCounter++;
        }
      }

      return data.pendingCounter > 0 ? true : false;
    },
    checkStatusCancelled(data) {
      for (let index = 0; index < data.staff.length; index++) {
        if (data.staff[index].status.toUpperCase() === "CANCELLED") {
          return true;
        }
      }
      return false;
    },
    checkOTDateVsCurrentDate(data) {
      let tempStartTime = new Date(data.start_time);
      let tempCurrentDate = new Date();
      return tempStartTime.getTime() <= tempCurrentDate.getTime();
    },
    checkOTDateVsLastApprovedTimeSheet(data) {
      let tempStartTime = new Date(data.start_time);
      return tempStartTime.getTime() <= this.tempCurrentDate.getTime();
    },
    disableWithDraw(data) {
      if (data.staff[0].status.toUpperCase() === "CANCELLED") {
        return true;
      }
      for (let index = 0; index < data.staff.length; index++) {
        if (data.staff[index].status.toUpperCase() === "APPROVED") {
          return this.checkOTDateVsCurrentDate(data);
        }
      }
      return this.checkOTDateVsLastApprovedTimeSheet(data);
    },
    disableApproveAll(data) {
      let disable = false;
      for (let index = 0; index < data.staff.length; index++) {
        if (
          data.staff[index].status.toUpperCase() === "REJECTED" ||
          data.staff[index].status.toUpperCase() === "CANCELLED" ||
          data.staff[index].status === "10"
        ) {
          return true;
        }
        if (data.staff[index].status.toUpperCase() === "APPROVED") {
          disable = true;
        } else {
          disable = false;
        }
      }
      return disable || this.checkOTDateVsLastApprovedTimeSheet(data);
    },
    disableRejectAll(data) {
      let disable = false;
      let tempCount = 0;
      if (data.staff[0].status.toUpperCase() === "CANCELLED" || data.staff[0].status === "10") {
        return true;
      }
      data.staff.forEach((element) => {
        if (element.status.toUpperCase() === "APPROVED") {
          if (this.checkOTDateVsCurrentDate(data)) {
            disable = true;
          }
        }
        if (element.status.toUpperCase() === "REJECTED") {
          tempCount++;
        }
      });
      return this.checkOTDateVsLastApprovedTimeSheet(data) || disable || tempCount === data.staff.length;
    },
    disableEdit(data) {
      let disable = false;
      data.staff.forEach((element) => {
        if (element.status.toUpperCase() !== "PENDING") {
          disable = true;
        }
      });
      return disable || this.checkOTDateVsLastApprovedTimeSheet(data);
    },
    disableMoreButton(data) {
      if (data.staff[0].status.toUpperCase() === "CANCELLED") {
        return true;
      }
      if (this.checkOTDateVsLastApprovedTimeSheet(data)) {
        return true;
      }
      let tempCount = 0;
      data.staff.forEach((element) => {
        if (element.status.toUpperCase() === "REJECTED") {
          tempCount++;
        }
      });
      let disable = tempCount === data.staff.length;
      return disable;
    },

    checkOTPaid(e) {
      this.isCheckedOTPaid = e.target.checked;
    },
    checkStatusExpired(data) {
      for (let index = 0; index < data.staff.length; index++) {
        if (data.staff[index].status === "10") {
          return true;
        }
      }
      return false;
    },
    // file choosen
    beforeUpload(file) {
      const result = beforeUploadFile(file);
      if (result.isValid) {
        this.fileList = [...this.fileList, file];
      } else {
        this.$message.error(result.message, 5);
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (this.overtimeType) {
        this.deleteFile(this.recordSelected.id, file.name);
      } else {
        this.deleteFile(this.formData.id, file.name);
      }
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleUpload(id) {
      const { fileList } = this;
      if (this.overtimeType) {
        if (fileList.length > 0) {
          const formData = new FormData();
          fileList.forEach((file) => {
            formData.append("file", file);
          });
          http
            .post(`/tms/overtime-management/v2/${id}/upload?file`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.status === 200) {
                this.$message.success("Upload file success");
                fileList.splice(0, fileList.length);
              } else {
                this.$message.error("Upload file failed");
              }
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        }
      } else {
        const formData = new FormData();

        fileList.forEach((file) => {
          formData.append("file", file);
        });
        http
          .post(`/tms/request-management/${this.request_type}/${id}/upload?file`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$message.success("Success");
            fileList.splice(0, fileList.length);
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    getAllListFile(id) {
      const { fileList, tabCurrent } = this;
      if (tabCurrent === FLEXIBLE_TAB) {
        http
          .get(`/tms/overtime-management/v2/${id}/get-all-file-upload`)
          .then((res) => {
            if (res.data) {
              let tempData = res.data;
              tempData.forEach((record) => {
                fileList.push(record);
              });
              if (fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return tempData;
            }
          })
          .catch((err) => {
            throw err;
          });
      } else {
        http
          .get(`/tms/request-management/${this.request_type}/get-all-file-list?id=` + id)
          .then((res) => {
            if (res.data) {
              let tempData = res.data;
              tempData.forEach((record) => {
                fileList.push(record);
              });
              if (fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return tempData;
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    deleteFile(id, name) {
      if (this.overtimeType) {
        return http
          .delete(`/tms/overtime-management/v2/${id}/${name}`)
          .then((res) => {
            if (res.status === 200) {
              this.$message.success(res.data);
              if (this.fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return true;
            } else false;
          })
          .catch((err) => {
            throw err;
          });
      } else {
        http
          .get(`/tms/request-management/${this.request_type}/${id}/delete-file?name=` + name)
          .then((res) => {
            this.$message.success(res.data);
            if (this.fileList.length > 0) {
              this.isAvaiableToDownLoad = true;
            } else {
              this.isAvaiableToDownLoad = false;
            }
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }
    },

    handleDownload() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/${this.request_type}/${this.formData.id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    exportRequest() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const { filters } = this;
        const paramFilter = convertObjectToParams({
          ...filters,
        });
        this.$store.dispatch("user/loadingRequest");
        http
          .get(`tms/excel/request-ot${paramFilter}`, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(
                res.data,
                `Overtime_List_${moment(filters.fromDate).format("DD/MM/yyyy")}-${moment(filters.toDate).format(
                  "DD/MM/yyyy"
                )}.xlsx`
              );
              this.$store.dispatch("user/loadingRequest", 5);
              this.$message.success("Request List is exported successfully!");
            } else {
              this.$store.dispatch("user/loadingRequest");
              this.$message.error("No data export", 5);
            }
          })
          .catch(async (error) => {
            this.$store.dispatch("user/loadingRequest");
            if (error.request.responseType === "blob" && error.response.data instanceof Blob) {
              const errorObject = JSON.parse(await error.response.data.text());
              this.$message.error(errorObject.message, 5);
            }
          });
      }, 500);
    },
    exportReport() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const { filters } = this;
        const paramFilter = convertObjectToParams({
          ...filters,
        });
        this.$store.dispatch("user/loadingRequest");
        http
          .get(`tms/excel/report-ot${paramFilter}`, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(
                res.data,
                `Report_OT_${moment(filters.fromDate).format("DD/MM/yyyy")}-${moment(filters.toDate).format(
                  "DD/MM/yyyy"
                )}.xlsx`
              );
              this.$store.dispatch("user/loadingRequest", 5);
              this.$message.success("Request List is exported successfully!");
            } else {
              this.$store.dispatch("user/loadingRequest");
              this.$message.error("No data export", 5);
            }
          })
          .catch(async (error) => {
            this.$store.dispatch("user/loadingRequest");
            if (error.request.responseType === "blob" && error.response.data instanceof Blob) {
              const errorObject = JSON.parse(await error.response.data.text());
              this.$message.error(errorObject.message, 5);
            }
          });
      }, 500);
    },
    disableWeekends(date) {
      return disableWeekendCommon(
        date.format(DATE_FORMAT_SHORT),
        this.lastTimesheet?.last_timesheet_period_end_date,
        TIME_STAFF,
        DATE_FORMAT_SHORT,
        this.timeServer
      );
    },
    importRequest() {
      clearTimeout(this.timeOut);
      this.isShowModalImport = true
    },
    handleCancelRequest() {
      this.formUpdate.resetFields();
  
      this.isShowModalImport = false;
    },
    async onImport(values, onSuccess) {
      try {
        this.fetching = true;
        const res = await this.$store.dispatch("timesheet/importFileOvertime", values);
        const { status } = res;
        handleMessagesAPI(res?.headers);
        if (status === 200) {
          this.$message.success("File Request OverTime is imported successfully!", 5);
          onSuccess()
          this.handleCancelRequest();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.fetching = false;
      }
    }
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
